var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                    class: { "bg-danger": !_vm.hasDependants },
                  },
                  [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Delete attribute: " + _vm._s(_vm.attributeName)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("×")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h4", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(
                          " Checking dependencies...\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized && _vm.hasDependants
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "alert alert-danger text-dark",
                            attrs: { role: "alert" },
                          },
                          [
                            _c("h5", { staticClass: "alert-heading" }, [
                              _vm._v("Cannot delete this attribute"),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("The attribute '"),
                              _c("strong", [_vm._v(_vm._s(_vm.attributeName))]),
                              _vm._v("' is used in "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.dependenciesCount)),
                              ]),
                              _vm._v(
                                " places.\n                                To delete this attribute, first remove it from where it is used."
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized && !_vm.hasDependants
                    ? _c("div", [
                        _c("h4", [
                          _vm._v(
                            "Are you sure you want to delete this attribute?"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("You are about to delete '"),
                          _c("strong", [_vm._v(_vm._s(_vm.attributeName))]),
                          _vm._v("'. This can't be undone."),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.initialized && _vm.hasDependants
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.emitShowDependencies },
                        },
                        [_vm._v("View dependencies")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized && !_vm.hasDependants
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: { type: "button" },
                          on: { click: _vm.emitDeleteAttribute },
                        },
                        [_vm._v("Delete")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }